/**
 * Mapeo de errores del backend a mensajes en español.
 *
 * Antes vivía como una cadena de `if/else if` dentro de `AddData`. Aquí se
 * vuelve declarativo: agregar un nuevo error solo requiere una entrada en
 * el diccionario.
 */

/** Diccionario código de error backend -> mensaje legible. */
const ERROR_MESSAGES = Object.freeze({
  'File not provided': 'Por favor proporcione un archivo',
  'Failed to add customer': 'No se pudo agregar al cliente',
  'This room is already reserved on the given checkIn Date':
    'Esta habitación ya está reservada en la fecha de entrada indicada',
  'Room already reserved': 'Habitación ya reservada'
});

const DEFAULT_RESERVATION_ERROR = 'No se pudo agregar la reserva';
const DEFAULT_NETWORK_ERROR = 'Algo salió mal. Por favor, inténtelo de nuevo.';

/**
 * Extrae un mensaje legible de la respuesta del API.
 *
 * @param {object} response - Respuesta de axios (puede venir como error)
 * @returns {string}
 */
export const extractReservationError = (response) => {
  const backendError = response?.response?.data?.error;
  if (!backendError) return DEFAULT_RESERVATION_ERROR;
  return ERROR_MESSAGES[backendError] || backendError || DEFAULT_RESERVATION_ERROR;
};

/**
 * Mensaje a mostrar cuando una excepción no controlada ocurre.
 *
 * @returns {string}
 */
export const networkErrorMessage = () => DEFAULT_NETWORK_ERROR;
